import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import ImprestDocumentsDrawer from "./ImprestDocumentsDrawer";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    imprestApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, imprestApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import ImprestApplicationForm from "./form";

const base_url = HRService.uri;

function ImprestApplicationsByUserTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedImprestForDocs, setSelectedImprestForDocs] = useState(null);

  const actions = {
  entity: "Imprest Applications",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

 // ---------- APPROVE ----------
 sendForapprovalImprest: {
      key: "SENDFORAPPROVAL",
      button_name: "Sent For Approval",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },

  // ---------- REJECT ----------
  REJECTIMPREST: {
    key: "REJECTIMPREST",
    button_name: "Reject",
    Show_Button: (row) => row.statusId === 1,   // only when pending
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
 ViewImprestLines: {
      key: "ViewImprestLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedImprestForDocs(row);
        setDocsDrawerOpen(true);
      },
    },  
  showStatus: true,
  };

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Imprest Applications"
          subtitle="View all your Imprest Applications, create or update it"
          columns={imprestApplicationsColumns}
          FormComponent={ImprestApplicationForm}
          query={imprestApplicationsByUser}
          actions={actions}
          base_url={base_url}
        />
        <ImprestDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedImprestForDocs(null);
          }}
          imprestId={selectedImprestForDocs?.id}
        />
      </>
    </Box>
  );
}

export default ImprestApplicationsByUserTable;
